import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DadosEmpresaRoutingModule } from './dados-empresa-routing.module';


@NgModule({
  imports: [
    CommonModule,
    DadosEmpresaRoutingModule
    
  ],
  declarations: []
})
export class DadosEmpresaModule { }
